import { lazy, Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import Home from 'pages/home';
import { GuestRoute, PricingRoute, ProtectedRoute, SubscriptionRoute } from 'routes/RouteGuards';
import { PATHS } from 'routes/paths';

const AccountPage = lazy(() => import('pages/account'));
const ForgotPasswordPage = lazy(() => import('pages/auth/forgot'));
const LoginPage = lazy(() => import('pages/auth/login'));
const SignupPage = lazy(() => import('pages/auth/signup'));
const LibraryPage = lazy(() => import('pages/library'));
const PricingPage = lazy(() => import('pages/pricing'));
const ImprintPage = lazy(() => import('pages/legal/imprint'));
const PrivacyPolicyPage = lazy(() => import('pages/legal/privacy'));
const TermsPage = lazy(() => import('pages/legal/terms'));
const UnsubscribePage = lazy(() => import('pages/unsubscribe'));
const NotFoundPage = lazy(() => import('pages/not-found'));
const Checkout = lazy(() => import('pages/checkout').then((module) => ({ default: module.Checkout })));

export default function AppRoutes() {
  const trailingSlashRedirects = [
    ['/pricing', PATHS.pricing],
    ['/unsubscribe', PATHS.unsubscribe],
    ['/library', PATHS.library],
    ['/signup', PATHS.signup],
    ['/login', PATHS.login],
    ['/forgot', PATHS.forgotPassword],
    ['/terms', PATHS.terms],
    ['/privacy', PATHS.privacy],
    ['/imprint', PATHS.imprint],
    ['/account', PATHS.account],
    ['/checkout', PATHS.checkout],
  ];

  return (
    <Suspense fallback={null}>
      <Routes>
        {trailingSlashRedirects.map(([from, to]) => (
          <Route key={from} path={from} element={<Navigate to={to} replace />} />
        ))}

        <Route path={PATHS.home} element={<Home />} />
        <Route path={PATHS.unsubscribe} element={<UnsubscribePage />} />
        <Route path={PATHS.privacy} element={<PrivacyPolicyPage />} />
        <Route path={PATHS.terms} element={<TermsPage />} />
        <Route path={PATHS.imprint} element={<ImprintPage />} />

        <Route element={<PricingRoute redirectTo={PATHS.library} />}>
          <Route path={PATHS.pricing} element={<PricingPage />} />
        </Route>

        <Route element={<GuestRoute redirectTo={PATHS.account} />}>
          <Route path={PATHS.login} element={<LoginPage />} />
          <Route path={PATHS.signup} element={<SignupPage />} />
          <Route path={PATHS.forgotPassword} element={<ForgotPasswordPage />} />
        </Route>

        <Route element={<SubscriptionRoute redirectTo={PATHS.pricing} />}>
          <Route path={PATHS.library} element={<LibraryPage />} />
        </Route>

        <Route element={<ProtectedRoute redirectTo={PATHS.login} />}>
          <Route path={PATHS.account} element={<AccountPage />} />
        </Route>
        <Route path={PATHS.checkout} element={<Checkout />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Suspense>
    
  );
}
